import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '@shared/queries';
import { useAddSnackbarMessage } from '@shared/useAddSnackBar';
import { ApiErr } from '@shared/entity';
import { getPendingReservations, approveReservation, denyReservation } from './api';
import { useAnalytics } from '@libs/mixpanel/useAnalytics';

export const PENDING_RESERVATIONS_KEY = ['pendingReservations'];

export const usePendingReservationsQuery = () =>
  useQuery({
    queryKey: PENDING_RESERVATIONS_KEY,
    queryFn: getPendingReservations,
    refetchInterval: 60_000,
  });

export const useApproveReservationMutation = () => {
  const addSnackbar = useAddSnackbarMessage();
  const { trackEvent } = useAnalytics();
  return useMutation({
    mutationFn: (id: string) => approveReservation(id),
    onSuccess: () => {
      trackEvent('online_reservation_received', { action: 'approved' });
      queryClient.invalidateQueries({ queryKey: PENDING_RESERVATIONS_KEY });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['searchClients'] });
      queryClient.invalidateQueries({ queryKey: ['visits'] });
      addSnackbar({ text: 'Rezervace byla schválena.', type: 'success' });
    },
    onError: (error: ApiErr) => {
      addSnackbar({
        text: error?.message || 'Rezervaci se nepodařilo schválit.',
        type: 'error',
      });
    },
  });
};

export const useDenyReservationMutation = () => {
  const addSnackbar = useAddSnackbarMessage();
  const { trackEvent } = useAnalytics();
  return useMutation({
    mutationFn: (id: string) => denyReservation(id),
    onSuccess: () => {
      trackEvent('online_reservation_received', { action: 'denied' });
      queryClient.invalidateQueries({ queryKey: PENDING_RESERVATIONS_KEY });
      addSnackbar({ text: 'Rezervace byla odmítnuta.', type: 'success' });
    },
    onError: () => {
      addSnackbar({ text: 'Rezervaci se nepodařilo odmítnout.', type: 'error' });
    },
  });
};
